import services from 'src/shared/services/services';
var default_1 = /** @class */ (function () {
    function default_1() {
        this.model = [];
    }
    default_1.prototype.load = function () {
        var _this = this;
        return services.Constant.getAll(null, null).then(function (c) { return (_this.model = c); });
    };
    default_1.prototype.get = function (id) {
        return this.model.find(function (c) { return c.id === id; });
    };
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/stores/ConstantStore.ts
// module id = 1260
// module chunks = 0